import React, { Component } from 'react';
import ThemedIcon from '../../components/common/ThemedIcon';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { connect } from 'react-redux';
import LoadingComponent from '../../components/common/LoadingComponent';
import NewBenefitsCard from '../../components/policy/newBenefitsCard';
import { BoldText, Text, SemiBoldText } from '../../components/common/Text';
import NewClaimsCard from '../../components/policy/NewClaimsCard';
import NewHelpCard from '../../components/policy/NewHelpCard';
import {
  InsureTabApi,
  InsureTabOpdBenefits,
  consultationTab,
  getConsultationSummary,
  getSvg,
} from '../../services';
import { logout } from '../../actions';
import { Carousel } from 'react-responsive-carousel';
import arrowLeft from '../../images/common/arrow-left.svg';
import Tappable from 'react-tappable/lib/Tappable';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import EyeIcon from '../../images/newInsurerPage/eyeIcon.svg';
import WalletCardBackground1 from '../../images/newInsurerPage/walletBackground1.svg';
import WalletCardBackground2 from '../../images/newInsurerPage/walletBackground2.svg';
import WalletCardBackground3 from '../../images/newInsurerPage/walletBackground3.svg';
import Header from '../../components/common/Header';

import PurpleDownArrow from '../../images/policy/purpleArrowDown.svg';
import BlueDownArrow from '../../images/policy/blueArrowDown.svg';
import GreenDownArrow from '../../images/policy/greenArrowDown.svg';
import NewHealthBenefitsCard from '../../components/policy/NewHealthBenefitsCard';
import WalletBalanceSection from '../../components/policy/WalletBalanceSection';
import { tabFormatter } from '../../utils';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  height: 100svh;
  background: #ffffff;
  overflow: hidden;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background: white;
`;

const Body = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 2rem;
  overflow-x: hidden;
`;

const SectionHeading = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 1rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
const Session = styled.div`
  width: 90%;
  margin: auto;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-top: 2px solid #e6e9ec;
`;

const slideIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const CardDiv = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #d9d9d9;
  border-radius: 20px;
  margin-right: 1rem;
  margin-left: 1rem;
`;
const CardHeader = styled.div`
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: space-between;
  align-items: center;
  background: #f5f4ff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;
const CardData = styled.div`
  display: flex;
  justify-content: space-between;
  width: 85%;
  margin: auto;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #e6e9ec;
`;

const CardInsurerLogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 35px;
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  align-items: center;
  background: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
`;
const CardTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
`;
const CardPtag = styled.p`
  display: flex;
  align-items: center;
  color: #666;

  font-size: 10px;
  font-weight: 500;
  line-height: normal;
`;
const CardPtag2 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;

  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
`;
const CardPtag3 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;

  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  padding: 0.5rem;
`;
const CarouselOuterContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
const BenefitsDocumentCard = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const BenefitsDocLinkContainer = styled.div`
  display: flex;
  width: 90%;
  margin: auto;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: 1px solid var(--text-box-card, #e6e9ec);
  background: var(--white, #fff);
`;
const WalletDetailsContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #ebe5ff;
  background: #fff;
`;
const TappableCard = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const WalletDetailsMain = styled.div`
  padding: 0.5rem;
  display: flex;
  background:
    ${(props) => `url(${props.bgSvg})`}, ${(props) => `${props.bgColor}`};
  flex-direction: column;
  border-radius: 10px;
  row-gap: 10px;
  margin: 0.8rem;
`;
const WalletDetailsDoop = styled.div`
  display: flex;
  background: ${(props) => `${props.bgColor}`};
  flex-direction: column;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  row-gap: 5px;
  width: 90%;
  margin: auto;
  padding-top: 0.8rem;
  border-top: 1px solid #e6e6e6;
`;
const ArrowContainerDoop = styled.div`
  display: flex;
  align-self: flex-start;
  color: var(--primary-button, #714fff);

  font-size: 9px;
  font-weight: 500;
  padding-bottom: 0.5rem;
`;
const WalletDetailsInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const DetailsLeft = styled.p`
  font-size: 12px;
  font-weight: 600;
  width: 60%;
`;
const DetailsRight = styled.p`
  font-size: 10px;
  font-weight: 600;
`;
const ArrowContainer = styled.div`
  display: flex;
  align-self: flex-end;
`;
const DetailsLeftDoop = styled.p`
  color: var(--primary-button, #714fff);

  font-size: 14px;
  font-weight: 600;
`;
const DetailsRightDoop = styled.p`
  color: var(--primary-button, #714fff);
  text-align: right;

  font-size: 16px;
  font-weight: 800;
`;
const Numerator = styled.span`
  padding-left: 5px;
  text-align: right;

  font-size: 14px;
  font-weight: 800;
`;
const Denominator = styled.span`
  font-size: 10px;
  font-weight: 600;
`;

const NumeratorDoop = styled.span`
  color: var(--primary-button, #714fff);
  text-align: right;

  font-size: 16px;
  font-weight: 800;
`;
const DenominatorDoop = styled.span`
  color: var(--primary-button, #714fff);

  font-size: 12px;
  font-weight: 600;
`;

const SlidingDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => `${props.bgColor}`};
  padding: 0.5rem;
  border-radius: 10px;
  row-gap: 10px;
  margin: 0.8rem;
  animation: ${slideIn} 0.4s ease-in-out;
`;

const SlidingDivCol1 = styled.div`
  display: flex;
  align-self: flex-start;
`;
const SlidingDivCol2 = styled.div`
  display: flex;
  justify-content: space-between;
`;
const SlidingInnerDiv = styled.div`
  display: flex;
  gap: 5px;
  font-size: 11px;

  align-items: center;
`;
const SlidingDivCol3 = styled.div`
  display: flex;
  font-size: 12px;
  align-self: flex-start;
  align-items: center;
`;

class OpdBenefits extends Component {
  constructor(props) {
    super(props);
    this.getConsoleApiResponse = this.getConsoleApiResponse.bind(this);

    this.state = {
      loading: true,
      insured: false,
      opdPolicies: [],
      ipdPolicies: [],
      claims: [],
      opdWalletDetails: [],
      policyDetails: {},
      policySavings: {},
      reimbursementRequests: null,
      coiUrl: null,
      activeTabIndex: 0,
      activeTab: '',
      opdDependentWallet: [],
      dependentSelectedWallet: {},
      opdEcards: [],
      benefitsSection: [],
      claimsSection: [],
      helpSection: [],
      offersSection: [],
      walletSection: [],
      selectedWalletKeyIndex: 0,
      currentOpenCard: null,
      healthBenefits: [],
      cards: [],
      policyDocumentLink: null,
      walletProgramType: null,
      walletProgramTagLabel: null,
      showFamilyTab: false,
      services: [],
      blockers: {},
      pageHeader: 'OPD',
      fulfillmentDetails: null,
    };
  }

  // Header() {
  //   return (
  //     <HeaderContainer>
  //       <Header>
  //         <BackContainer onTap={() => this.props.history.goBack()}>
  //           <img src={arrowLeft} alt="back" />{' '}
  //         </BackContainer>
  //         <HeaderText>Opd Benefits Details</HeaderText>
  //       </Header>
  //     </HeaderContainer>
  //   );
  // }

  requestReimbursement = (ele) => {
    const { fulfillmentDetails, onlyClaims } = this.state;
    const { history } = this.props;

    if (fulfillmentDetails?.fulfillmentDetailsAvailable || onlyClaims) {
      if (fulfillmentDetails?.spGlobalReimbursementFlow === 1) {
        history.push('/new-reimbursement/preview');
      } else {
        history.push('/reimbursement');
      }
    } else {
      history.push('/reimbursement/fulfillment-details', {
        fulfillmentDetailsAvailable: false,
        from: 'normal-flow',
        details: fulfillmentDetails,
        isSAndPFlow: fulfillmentDetails?.spGlobalReimbursementFlow === 1,
      });
    }
  };

  getConsoleApiResponse() {
    const { authToken, showHra } = this.props;
    consultationTab(authToken)
      .then((res) => {
        const services = res.console;
        console.log('>>>>Services', services);
        if (showHra) {
          services?.push(this.state.hraCard[0]);
        }
        const reimbursementDetails = services?.filter(
          (c) => c.cardType === 'reimbursement'
        );
        const reimbursementDetailsObject = reimbursementDetails[0]
          ? reimbursementDetails[0]
          : null;
        const prePostDetails = services?.filter(
          (p) => p.cardType === 'hospitalisation'
        )?.[0];
        this.setState({
          loading: false,
          consoleCards: services,
          htmlCards: services?.filter((s) => s.cardType === 'html'),
          // blockers: res.blockers,
          fulfillmentDetails: reimbursementDetailsObject,
          hospitalisationKeys: {
            gmcApiFlow: prePostDetails?.gmcApiFlow,
            gmcServiceFlow: prePostDetails?.gmcServiceFlow,
            treatmentCategory: prePostDetails?.treatmentCategory,
          },
          showPrePostButton:
            prePostDetails?.prePostInfo?.prePostEnabled || false,
          showCashlessClaimButton: Boolean(
            prePostDetails?.canIntimateClaimForPolicy
          )
            ? true
            : false,
          showReimbusementClaimButton: Boolean(
            prePostDetails?.canSubmitClaimForPolicy
          )
            ? true
            : false,
        });

        if (!reimbursementDetailsObject) {
          this.setState({
            onlyClaims: true,
          });
        }
        this.getHraPdfLink();
      })
      .catch((err) => {
        console.error(err);
        if (
          err?.response?.data?.errorMessage ===
          'You have been blocked to use the app.'
        ) {
          this.props.dispatch(logout(this.props.history));
        }
      })
      .finally(() => {
        this.setState({ dashboardApiLoaded: true });
      });
  }

  findSpecialist = (pendingConsult, cancelledRequest) => {
    const { history, authToken, userId } = this.props;
    if (cancelledRequest > 0) {
      history.push('/consultation/cancel-blocker', {
        requestId: cancelledRequest,
      });
    } else if (pendingConsult > 0) {
      getConsultationSummary(pendingConsult, userId, authToken)
        .then((summary) => {
          const { dateLabel, doctorId, doctorName, doctorImg } =
            summary.consultationInfo;
          this.setState({
            pendingConsult: {
              consultationId: pendingConsult,
              doctorId,
              doctorImg,
              doctorName,
              dateLabel,
            },
            showModal: true,
            showPendingConsultBlocker: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      history.push('/consultation/preview', {
        specialistSearch: false,
        searchType: 'find',
      });
    }
  };
  startTreatment = (showSearch, pendingConsult, cancelledRequest) => {
    const { history, authToken, userId } = this.props;
    if (cancelledRequest > 0) {
      history.push('/consultation/cancel-blocker', {
        requestId: cancelledRequest,
      });
    } else if (pendingConsult > 0) {
      getConsultationSummary(pendingConsult, userId, authToken)
        .then((summary) => {
          const { dateLabel, doctorId, doctorName, doctorImg } =
            summary.consultationInfo;
          this.setState({
            pendingConsult: {
              consultationId: pendingConsult,
              doctorId,
              doctorImg,
              doctorName,
              dateLabel,
            },
            showModal: true,
            showPendingConsultBlocker: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      history.push('/consultation/online/preview', {
        specialistSearch: false,
        searchType: 'find',
        showSearch,
      });
    }
  };
  renderService(ele, stng) {
    const { cardType } = ele;
    if (cardType === stng) {
      switch (cardType) {
        case 'online-consults':
          this.startTreatment(
            ele.allowSearch,
            ele.pendingConsult,
            ele.cancelledRequest
          );
          break;

        case 'offline-consults':
          this.findSpecialist(ele.pendingConsult, ele.cancelledRequest);
          break;

        case 'reimbursement':
          this.requestReimbursement(ele);
          break;

        default:
          return false;
      }
    }
  }
  getItDone(stng) {
    if (this.state.services.length > 0) {
      this.state.services.map((item) => this.renderService(item, stng));
    }
  }
  getAppropriateRoute(key) {
    switch (key) {
      case 'dental':
        return this.props.history.push('/dental/preview');
      case 'labs':
        return this.props.history.push('/lab-test');
      case 'pharmacy':
        return this.props.history.push('/pharmacy');
      case 'reimbursement':
        this.getItDone('reimbursement');
        break;
      case 'offline-consult':
        this.getItDone('offline-consults');
        break;
      case 'online-consult':
        this.getItDone('online-consults');
        break;
      case 'help':
        return this.props.history.push('/home/insure/faq?hidetabs=true');
      case 'vaccination':
        return this.props.history.push('/vaccination/preview');
      default:
        return '';
    }
  }
  getConsults() {
    const { authToken, history } = this.props;
    consultationTab(authToken)
      .then((res) => {
        const services = res.console;
        this.setState({
          services,
          blockers: res.blockers,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getBackground(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return WalletCardBackground1;
      case 1:
        return WalletCardBackground2;
      case 2:
        return WalletCardBackground3;
      default:
        return '';
    }
  }
  getBackgroundColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;

    switch (backgroundIndex) {
      case 0:
        return 'linear-gradient(132deg, rgba(249, 126, 124, 0.20) 0%, rgba(255, 109, 162, 0.10) 95.83%)';
      case 1:
        return 'linear-gradient(136deg, #C7EBFF 0%, rgba(211, 237, 255, 0.56) 91.69%)';
      case 2:
        return 'linear-gradient(151deg, rgba(146, 220, 70, 0.20) 0.01%, rgba(232, 228, 110, 0.20) 100%)';
      default:
        return '';
    }
  }
  getArrow(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return PurpleDownArrow;
      case 1:
        return BlueDownArrow;
      case 2:
        return GreenDownArrow;
      default:
        return '';
    }
  }
  getIcon(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return 'brightness(0) saturate(100%) invert(81%) sepia(63%) saturate(5061%) hue-rotate(314deg) brightness(86%) contrast(105%)';
      case 1:
        return 'brightness(0) saturate(100%) invert(42%) sepia(83%) saturate(620%) hue-rotate(161deg) brightness(92%) contrast(74%)';
      case 2:
        return 'brightness(0) saturate(100%) invert(68%) sepia(12%) saturate(2351%) hue-rotate(35deg) brightness(94%) contrast(89%)';
      default:
        return '';
    }
  }

  getTextColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return '#E16262';
      case 1:
        return '#2E89BD';
      case 2:
        return '#90B529';
      default:
        return '';
    }
  }
  onCardTap(index) {
    if (this.state.currentOpenCard === index) {
      this.setState({ currentOpenCard: null });
    } else {
      this.setState({ currentOpenCard: index });
    }
  }

  renderBody() {
    const {
      walletSections,
      opdEcards,
      selectedWalletKeyIndex,
      cards,
      walletProgramType,
      walletProgramTagLabel,
      showFamilyTab,
    } = this.state;

    const walletDetails =
      walletSections?.[selectedWalletKeyIndex]?.walletDetails;
    const isWalletRevamp = !!walletProgramType && walletSections?.length > 0;
    const claimCard = cards.find((card) => card.key === 'claims')?.cards?.[0];
    const helpCard = cards.find((card) => card.key === 'help')?.cards?.[0];
    return (
      <div>
        <CarouselOuterContainer>
          <Carousel
            showIndicators={false}
            showStatus={false}
            centerMode={true}
            showThumbs={false}
            swipeable
            centerSlidePercentage={opdEcards?.length > 1 ? '90' : '100'}
          >
            {opdEcards?.map((eCard) => {
              return (
                <CardDiv key={eCard.age}>
                  <CardHeader>
                    <CardInsurerLogoContainer>
                      <img src={eCard.insurerLogo} alt="" />
                    </CardInsurerLogoContainer>
                    <CardTitle>{eCard.header || 'OPD'} E-Card</CardTitle>
                  </CardHeader>
                  <CardData>
                    <CardPtag>Member Name</CardPtag>

                    <CardPtag2>{eCard.memberName}</CardPtag2>
                  </CardData>
                  <CardData>
                    <CardPtag>Age</CardPtag>

                    <CardPtag2>{eCard.age}</CardPtag2>
                  </CardData>
                  <CardData>
                    <CardPtag>Policy Number</CardPtag>

                    <CardPtag2>{eCard.policyNumber}</CardPtag2>
                  </CardData>
                  <CardData>
                    <CardPtag>Valid Till</CardPtag>

                    <CardPtag2>{eCard.validTill}</CardPtag2>
                  </CardData>
                  <CardFooter>
                    <div className="flex flex-col">
                      <CardPtag>Corporate Name</CardPtag>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'left',
                        }}
                      >
                        <img
                          src={eCard.sponsorLogo}
                          style={{ height: '24px' }}
                          alt=""
                        />
                      </div>
                    </div>
                  </CardFooter>
                </CardDiv>
              );
            })}
          </Carousel>
        </CarouselOuterContainer>

        {this.state.policyDocumentLink && (
          <BenefitsDocumentCard
            onTap={() => window.open(this.state.policyDocumentLink, '_blank')}
          >
            <BenefitsDocLinkContainer>
              <ThemedIcon src={EyeIcon} alt="" />
              <CardPtag3>View Benefits Document</CardPtag3>
            </BenefitsDocLinkContainer>
          </BenefitsDocumentCard>
        )}
        {isWalletRevamp && (
          <WalletBalanceSection
            walletSections={walletSections}
            walletProgramTagLabel={walletProgramTagLabel}
            showFamilyTab={showFamilyTab}
          />
        )}
        {!isWalletRevamp && walletDetails?.length > 0 && (
          <Session>
            <SectionHeading>
              Your Wallet Balance
              {walletSections.length > 1 && (
                <div className="border rounded-12 border-txtsecondary px-2 py-1">
                  <select
                    className="border-none outline-none"
                    onChange={(e) =>
                      this.setState({ selectedWalletKeyIndex: e.target.value })
                    }
                  >
                    {walletSections?.map((item, index) => (
                      <option key={index} value={index}>
                        {item.WalletDepName}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </SectionHeading>
            <WalletDetailsContainer>
              {walletDetails?.map((item, index) => (
                <TappableCard onTap={() => this.onCardTap(index)}>
                  <WalletDetailsMain
                    bgSvg={this.getBackground(index)}
                    bgColor={this.getBackgroundColor(index)}
                  >
                    <WalletDetailsInner>
                      <DetailsLeft style={{ color: this.getTextColor(index) }}>
                        {item.newLabel}
                      </DetailsLeft>
                      <DetailsRight style={{ color: this.getTextColor(index) }}>
                        {!item.hideWallet ? (
                          item.isUnlimitedTitle ? (
                            <Numerator
                              style={{ color: this.getTextColor(index) }}
                            >
                              Unlimited
                            </Numerator>
                          ) : (
                            <>
                              <Numerator
                                style={{ color: this.getTextColor(index) }}
                              >
                                ₹ {item.availableBalanceText} /
                              </Numerator>
                              <Denominator
                                style={{ color: this.getTextColor(index) }}
                              >
                                ₹ {item.totalBalanceText}
                              </Denominator>
                            </>
                          )
                        ) : null}
                      </DetailsRight>
                    </WalletDetailsInner>
                    <ArrowContainer>
                      <img src={this.getArrow(index)} alt="" />
                    </ArrowContainer>
                  </WalletDetailsMain>
                  {index === this.state.currentOpenCard && (
                    <SlidingDiv bgColor={this.getBackgroundColor(index)}>
                      <SlidingDivCol1>
                        <Numerator style={{ color: this.getTextColor(index) }}>
                          Benefits
                        </Numerator>
                      </SlidingDivCol1>
                      {item.servicesCovered?.map((serviceItem) => {
                        return (
                          <SlidingDivCol2>
                            <SlidingInnerDiv
                              style={{
                                color: this.getTextColor(index),
                              }}
                            >
                              <img
                                src={serviceItem.icon}
                                style={{
                                  width: '20px',
                                  filter: this.getIcon(index),
                                }}
                                alt=""
                              />

                              {serviceItem.label}
                            </SlidingInnerDiv>
                            <SlidingInnerDiv
                              style={{
                                color: this.getTextColor(index),
                              }}
                            >
                              ₹{' '}
                              {serviceItem.benefitBalance
                                ? `${serviceItem.amountSpent}/
                                ${
                                  Number(serviceItem.benefitBalance) ===
                                  10000000
                                    ? 'Unlimited'
                                    : '₹ ' + serviceItem.benefitBalance
                                }`
                                : serviceItem.amountSpent}
                            </SlidingInnerDiv>
                          </SlidingDivCol2>
                        );
                      })}
                      {!item.hideWallet && (
                        <SlidingDivCol3
                          style={{ color: this.getTextColor(index) }}
                        >
                          Total Spends{' '}
                          <Numerator>
                            {' '}
                            ₹ {item.servicesCovered && item.totalSpent}
                          </Numerator>
                        </SlidingDivCol3>
                      )}
                    </SlidingDiv>
                  )}
                </TappableCard>
              ))}
              <WalletDetailsDoop>
                <WalletDetailsInner>
                  <DetailsLeftDoop>Available Balance</DetailsLeftDoop>
                  <DetailsRightDoop>
                    {walletDetails[0].isUnlimitedTitle ? (
                      <>{walletDetails[0].isUnlimitedText}</>
                    ) : (
                      <>
                        <NumeratorDoop>
                          ₹ {walletDetails[0].availableBalanceText}/
                        </NumeratorDoop>
                        <DenominatorDoop>
                          ₹ {walletDetails[0].totalBalanceText}
                        </DenominatorDoop>
                      </>
                    )}
                  </DetailsRightDoop>
                </WalletDetailsInner>
                <ArrowContainerDoop>
                  {walletDetails[0].description}
                </ArrowContainerDoop>
              </WalletDetailsDoop>
            </WalletDetailsContainer>
          </Session>
        )}

        {this.state?.healthBenefits?.length > 0 && (
          <Session>
            <SectionHeading>Health Benefits</SectionHeading>
            <div className="flex flex-col gap-4">
              {this.state.healthBenefits.map((item) => (
                <NewHealthBenefitsCard
                  className="clickable"
                  data={item}
                  onTap={() => {
                    if (item.title === 'Reimbursements') {
                      this.requestReimbursement(item);
                      console.log('hello--=--=-=->', item);
                    } else {
                      item.redirectTo &&
                        this.props.history.push(tabFormatter(item.redirectTo));
                      // console.log('hello--=--=-=->', item);
                    }
                  }}
                />
              ))}
            </div>
          </Session>
        )}
        {claimCard && (
          <Session>
            <SectionHeading>Claims</SectionHeading>
            <NewClaimsCard
              data={claimCard}
              onTap={() => this.props.history.push('/claims')}
            />
          </Session>
        )}
        {helpCard && (
          <Session>
            <SectionHeading>Help</SectionHeading>

            <NewHelpCard
              data={helpCard}
              onTap={() => this.getAppropriateRoute(helpCard.themeKey)}
            />
          </Session>
        )}
      </div>
    );
  }
  fetchData() {
    const { authToken } = this.props;
    const { state } = this.props.location;
    if (state && state.policyId) {
      InsureTabOpdBenefits(authToken, state.policyId)
        .then((response) => {
          const opdData = response;
          console.log('==--==--==>>', opdData);
          this.setState({
            opdEcards: opdData.opdPolicies.eCards,
            walletSections: opdData.opdUniqueWallets,
            healthBenefits: opdData.opdPolicies.healthBenefits,
            cards: opdData.cards || [],
            policyDocumentLink: opdData.policyDocumentLink,
            pageHeader: opdData.pageHeader,
            walletProgramType: opdData.walletProgramType,
            walletProgramTagLabel: opdData.walletProgramTagLabel,
            showFamilyTab: opdData.showFamilyTab,
          });
        })
        .catch((err) => console.log('err is', err))
        .finally(() => this.setState({ loading: false }));
    }
  }

  componentDidMount() {
    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      this.props.history.push('/');
    } else {
      this.getConsults();
      this.fetchData();
      this.getConsoleApiResponse();
    }
  }
  render() {
    return (
      <OuterContainer>
        {/* {this.Header()} */}
        <Header title={`${this.state.pageHeader || 'OPD'} Benefits Details`} />
        {this.state.loading ? (
          <LoadingComponent />
        ) : (
          <BodyContainer>
            <Body>{this.renderBody()}</Body>
          </BodyContainer>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  profileImage: state.user.profileImage,
  sponsorId: state.user.sponsorId,
  showSubscription: state.app.config.showSubscription,
  showOPD: state.app.config.showOPD,
  insured: state.app.config.insured,
  userId: state.user.userId,
  subscribed: state.app.config.subscribed,
});

export default connect(mapStateToProps)(OpdBenefits);
